import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {isSchemaTag, SchemaTag, Tag} from 'folder-items/FileConstants';
import {getRequiredLinkTagSchema, SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {filterToSchemaTags} from 'schemas/tags/TagUtil';

function _isParentLinkMixtureField(schemaField: SchemaField): boolean {
  if (schemaField.isParentLink) {
    const requiredLinkTagSchema = getRequiredLinkTagSchema(schemaField);
    assert(
      requiredLinkTagSchema != null,
      'Expected parent link schema field to have required link tag schema'
    );
    return requiredLinkTagSchema.folderItemType === ModelTypeConstants.MIXTURE;
  }
  return false;
}

export function getParentLinkMixtureTag(tags: Array<Tag>): SchemaTag | undefined {
  return filterToSchemaTags(tags).find(
    (tag: Tag) => isSchemaTag(tag) && _isParentLinkMixtureField(tag.tagSchemaField)
  );
}

export function getParentLinkMixtureField(fields: Array<SchemaField>): SchemaField | undefined {
  return fields.find((field) => _isParentLinkMixtureField(field));
}
